import { PermissionI } from 'types';
import { create } from 'zustand';

type PermissionT = PermissionI & { assigned: boolean };

interface PermissionState {
  permissions: PermissionT[];
}

interface PermissionActions {
  setPermissions(permissions: PermissionT[]): void;
}

export const usePermissionStore = create<PermissionState & PermissionActions>()(set => ({
  permissions: [],
  setPermissions(permissions) {
    set(() => ({
      permissions,
    }));
  },
}));
